<template>
  <div>
    <item-name :item="item" />
  </div>
</template>

<script>
import ItemMixin from './item-mixin'
import ItemName from './item-name'

export default {
  components: {
    ItemName
  },
  mixins: [
    ItemMixin
  ],
  props: {
    item: {
      type: Object,
      required: true
    }
  }
}
</script>
